import * as React from "react";
const SvgLeftArrow = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14 6L8 12L14 18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
export default SvgLeftArrow;
